// src/Utils/imageUploadUtils.js

export const validateImageFile = (file, { maxSizeMB = 5 } = {}) => {
  if (!file) {
    throw new Error("Please select an image");
  }

  if (!file.type?.startsWith("image/")) {
    throw new Error("Please select a valid image");
  }

  const maxSizeBytes = maxSizeMB * 1024 * 1024;

  if (file.size > maxSizeBytes) {
    throw new Error(`Image size must be under ${maxSizeMB}MB`);
  }

  return true;
};

export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error("Image file missing"));
      return;
    }

    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result;

      if (!result || typeof result !== "string") {
        reject(new Error("Unable to read image"));
        return;
      }

      // ORIGINAL DATA URL
      resolve(result);
    };

    reader.onerror = () => {
      reject(new Error("Image read failed"));
    };

    reader.readAsDataURL(file);
  });
};

// ============================================================
// COMMON IMAGE UPLOAD
// ============================================================

export const uploadItemImage = async ({
  anlookApi,
  userid,
  itemName,
  file = null,
  imageData = "",
  type = "IMG",
  maxSizeMB = 5,
}) => {
  if (!anlookApi) {
    throw new Error("Anlook API instance missing");
  }

  if (!userid) {
    throw new Error("User ID missing");
  }

  if (!itemName) {
    throw new Error("Item name missing");
  }

  let finalImageData = imageData;

  // New preferred flow: original File
  if (file) {
    validateImageFile(file, {
      maxSizeMB,
    });

    finalImageData = await fileToBase64(file);
  }

  // Backward compatibility
  if (!finalImageData) {
    throw new Error("Image data missing");
  }

  const response = await anlookApi.post("/v1/uploadItemImagev2.php", {
    userid: String(userid),
    item_name: itemName,
    type,
    image_data: finalImageData,
  });

  const data = response?.data;

  if (String(data?.status) === "0" && data?.image_url) {
    return {
      success: true,
      imageUrl: data.image_url,
      imageName: data.image_name || "",
      response: data,
    };
  }

  throw new Error(
    data?.msg ||
      data?.message ||
      data?.responseMessage ||
      "Image upload failed",
  );
};
